import { EffectCallback, useEffect, useEffectEvent, useRef } from "react";

export function useEffectOnce(effect: EffectCallback) {
    const hasRun = useRef(false);
    const runEffect = useEffectEvent(effect);

    useEffect(() => {
        if (hasRun.current) {
            return;
        }

        hasRun.current = true;
        return runEffect();
    }, []);
}
